import { IIvcf } from '@medlogic/shared/shared-interfaces';

export interface IIvcfState {
    ivcf: IIvcf;
    ivcfs: IIvcf[];
    error?: any;
    ivcfId?: number;
}
